module.exports = __webpack_public_path__ + "img/minifarm.bd43f5d3.png";